import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Card } from 'antd';
import ChartFilters from './charts/ChartFilters';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

interface StatusBreakDownProps {
  statusBreakdownPerMonth: any[];
  onFilterChange: (data: {
    period: string;
    fromDate: string;
    toDate: string;
  }) => void;
}

const StatusBreakDown = ({
  statusBreakdownPerMonth,
  onFilterChange,
}: StatusBreakDownProps) => {

  const data = {
    labels: statusBreakdownPerMonth.map((d) => d.label),
    datasets: [
      {
        label: 'Approved',
        data: statusBreakdownPerMonth.map((d) => d.approved),
        backgroundColor: '#2C5F34',
        borderRadius: 4,
        minBarLength: 3,   // 🔥 THIS LINE
      },
      {
        label: 'Rejected',
        data: statusBreakdownPerMonth.map((d) => d.rejected),
        backgroundColor: '#FF0000',
        borderRadius: 4,
        minBarLength: 3,   // 🔥 THIS LINE
      },
      {
        label: 'Pending',
        data: statusBreakdownPerMonth.map((d) => d.pending),
        backgroundColor: '#FFCE1B',
        borderRadius: 4,
        minBarLength: 3,   // 🔥 THIS LINE
      },
    ],
  };


  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="w-full mt-8">
      <Card
        className="w-full"
        title={
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <span className="font-semibold">
              Status Breakdown Per Month
            </span>

            <ChartFilters
              showDateFilter
              showPeriodFilter
              onChange={onFilterChange}
            />
          </div>
        }
      >
        <div className="w-full h-[280px] sm:h-80 md:h-[380px]">
          <Bar data={data} options={options} />
        </div>
      </Card>
    </div>
  );
};

export default StatusBreakDown;
